export enum AffordabilityType {
  Res = 1,
  Btl = 2,
}

export enum UkLocation {
  EastMidlands = 1,
  EastOfEngland = 2,
  GreaterLondon = 3,
  NorthEast = 4,
  NorthWest = 5,
  SouthEast = 6,
  SouthWest = 7,
  WestMidlands = 8,
  YorkshireAndHumberside = 9,
  Scotland = 11,
  Wales = 12,
}
export enum PropertyType {
  House = 1,
  Flat = 2,
}
export enum MortgageType {
  Purchase = 1,
  Remortgage = 2,
}

export enum PurchaserType {
  FirstTimeBuyer = 1,
  HomeMover = 2,
}
export enum OwnerOccupier {
  Yes = 1,
  No = 2,
}
export enum FirstTimeBuyer {
  Yes = 1,
  No = 2,
}
export enum RemortgageReason {
  Purchase = 1,
  PurchaseAdditionalShares = 2,
  PoundForPound = 3,
  Other = 4,
}
export enum RemortgageType {
  LetToBuy = 1,
  LikeForLike = 2,
  CapitalRaising = 3,
}
export enum RepaymentMethod {
  CapitalAndInterest = 1,
  InterestOnly = 2,
  InterestOnlyPartAndPart = 3,
}
export enum RepaymentVehicle {
  SaleOfProperty = 1,
  SaleOfSecondProperty = 2,
  EndowmentsInvestmentsPension = 3,
  SavingsISA = 4,
}
export enum EmploymentStatus {
  Employed = 1,
  SelfEmployed = 2,
  DirectorOrShareholder = 3,
  Homemaker = 4,
  Retired = 5,
  Student = 6,
  Unemployed = 7,
}
export enum WorkRelatedIncomeType {
  Bonus = 1,
  Commission = 2,
  Overtime = 3,
  BankWork = 4,
  // Bursary = 5,
  // FosterIncome = 6,
  // Stipend = 7,
  CarAllowance = 8,
  LargeTownAllowance = 9,
  LondonWeighting = 10,
  ShiftAllowance = 11,
}
export enum WorkRelatedIncomeTypeBtl {
  Bonus = 1,
  Commission = 2,
  Overtime = 3,
  CarAllowance = 4,
  // ChildBenefit = 5,
  // ChildTaxCredits = 6,
  ShiftAllowance = 7,
  // UniversalCredit = 8,
  Maintenance = 9,
  // DlaOrPip = 10,
  // CarersAllowance = 11,
  // WorkingTaxCredits = 12,
}

export enum ExpenditureForSubjectPropertyType {
  MonthlyPropertyMaintenance = 1,
  GroundRentServiceCharge = 2,
  Certificates = 3,
  BoilerCover = 4,
}

export enum OtherIncomeType {
  // InvestmentIncome = 1,
  LodgerIncome = 2,
  RentalIncome = 3,
  Maintenance = 4,
}

export enum BuyForUniIncomeType {
  StudentRoomRent = 1,
}

export enum Frequency {
  Annually = 1,
  HalfYearly = 2,
  Quarterly = 3,
  Monthly = 4,
  FourWeekly = 5,
  Fortnightly = 6,
  Weekly = 7,
}
export enum ProductLength {
  OneYear = 1,
  TwoYears = 2,
  ThreeYears = 3,
  FourYears = 4,
  FiveYears = 5,
}

export enum BtlType {
  Standard = 1,
  HMO = 2,
  MultiBlockUnit = 3,
  HolidayLet = 4,
  CommercialProperty = 5,
}

export enum PropertyUse {
  Rental = 1,
  OwnUse = 2,
}

export enum ApplicantCountry {
  England = 1,
  Scotland = 3,
  Wales = 4,
  OutsideUk = 5,
}

export enum AffordabilitySource {
  ScreenScrape = 'ScreenScrape',
  Asanto = 'Asanto',
}

export enum SkipListKeys {
  Age = 'Age',
  AgeAtEndOfMortgage = 'AgeAtEndOfMortgage',
  EquityValue = 'EquityValue',
  HelpToBuyScheme = 'HelpToBuyScheme',
  HouseOrFlat = 'HouseOrFlat',
  LoanAmount = 'LoanAmount',
  LoanTermYears = 'LoanTermYears',
  Ltv = 'LTV',
  MortgageType = 'MortgageType',
  NewBuild = 'NewBuild',
  NumberOfApplicants = 'NumberOfApplicants',
  PropertyLocation = 'PropertyLocation',
  PropertyValue = 'PropertyValue',
  RemortgageReason = 'RemortgageReason',
  RepaymentVehicle = 'RepaymentVehicle',
  SoleOrJoint = 'SoleOrJoint',
}

export enum AffordabilityResponseErrorStatusCode {
  LtvTooHigh = 'LtvTooHigh',
  TooOld = 'TooOld',
  TimeoutReceivingResult = 'TimeoutReceivingResult',
  ContactLender = 'ContactLender',
  TooManyMortgages = 'TooManyMortgages',
}

export enum AffordabilityLenderAuditType {
  Approval = 1,
  ProductUpload = 2,
}

export enum AffordabilityLenderAudit {
  ErrorReported = 0,
  Approved = 1,
  NotCompleted = 2,
  NotApplicable = 3,
}

export enum AffordabilityServiceState {
  NotStarted = 0,
  Loading = 1,
  Complete = 2,
  Errored = 3,
}
